export default {"src":"/_next/static/media/EthicalPractices.346fc8b0.svg","height":47,"width":47,"blurWidth":0,"blurHeight":0};